export default __webpack_public_path__ + "static/teamPhoto3-ff9625a3c47c2dc8abfe18c16fb95500.png";